import { WarningOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import styled from 'styled-components';
import Typography from 'antd/lib/typography/Typography';
import { StyledIconWrapper } from 'components/new-ui/base/modal/styles';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { ManifestDeclarationsResponse } from 'store/manifests/types';
import ListItem from './ListItem';

type Props = {
    open: boolean;
    data: ManifestDeclarationsResponse[];
    onClose: () => void;
    onConfirm: () => void;
};

const StyledList = styled.ul`
    > li {
        padding-top: 6px;
    }

    > li:not(:last-child) {
        border-bottom: 1px solid var(--gray-4);
        padding-bottom: 6px;
    }
`;

const NonAmendableDeclarationsModal = ({ open, data, onClose, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            title="Non-amendable declarations"
            confirmButtonText="Continue Anyway"
            maskClosable={false}
            open={open}
            onClose={onClose}
            onCancel={onClose}
            onConfirm={onConfirm}
            icon={
                <StyledIconWrapper style={{ backgroundColor: 'var(--orange-1)' }}>
                    <WarningOutlined style={{ color: 'var(--orange-6)' }} />
                </StyledIconWrapper>
            }
            content={
                <Space style={{ width: '100%', padding: 16 }} direction="vertical" size={24}>
                    <Typography>
                        This manifest contains declarations that aren't in an amendable status. Your changes will not be
                        applied to them.
                    </Typography>

                    <StyledList style={{ maxHeight: 300, overflowY: 'auto', padding: 0, margin: 0 }}>
                        {data.map((job) => (
                            <ListItem key={job.jobId} {...job} />
                        ))}
                    </StyledList>
                </Space>
            }
        />
    );
};

export default NonAmendableDeclarationsModal;
